import { FC } from 'react';
import styled from 'styled-components';
import { Label } from '../Label/Label';

export type FromGroupVariation = 'inline';

const FormGroupElement = styled.div`
  margin-bottom: 1.875rem;
  > label {
    display: block;
    margin-bottom: 15px;
  }
`;

const FormGroupChildrenElement = styled.div<IProps>`
  display: flex;
  flex-direction: column;
  & > * {
    margin-right: 1rem;
    :last-child {
      margin-bottom: 0;
    }
  }
  &.inline {
    flex-direction: row;
    > * {
      margin-bottom: 0;
      flex: ${props => (props.childrenSpanWidth ? 1 : 'none')};
      :last-child {
        margin-right: 0;
      }
    }
  }
`;

export interface IProps {
  /** Group label */
  label?: string;
  /** stacked (default) | 'inline' */
  variation?: FromGroupVariation;
  /** fill width */
  childrenSpanWidth?: boolean;
}

export const FormGroup: FC<IProps> = props => {
  return (
    <FormGroupElement>
      {props.label && <Label name={props.label} variation="form" />}
      <FormGroupChildrenElement
        childrenSpanWidth={props.childrenSpanWidth}
        className={props.variation ? props.variation : ''}
      >
        {props.children}
      </FormGroupChildrenElement>
    </FormGroupElement>
  );
};
